function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  width: 11,
  height: 11,
  transform: "rotate(90 11 0)",
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_107_959",
  transform: "scale(0.0078125)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_107_959",
  width: 128,
  height: 128,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAEb0lEQVR4Ae2dS4rVQBhGv8bHRMQFCKJj0TU4EFyFqCMRezcOFEEnOhHfDlyF4AoEwQ2IijpS+Vt/6Zub3FRSj1SSU3Cpm6RSj3O+TrxtuC1RIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEBgQQSOSroo6bqkq5LOSzqyoPUtdSnmyFyZM3NnDs1lcDkn6a2kn5J+N17fJb2QdDq4NxqWImBOzI05anozl+bU3HaWPUn7kr61dNDs8LOkG509caA0AXNhTpqemtvm1hyb661yL6CDZoePuC1scSy5wy735qDppW/7bnOSV0Z04oM8JgRNnEW2Tb6xdw9D68s+y1OSPkV0ZAMTAqdZpo6Vb84+Sjpp070dKd+TRwjmI9+d3bIpP0wUAK4E+QOQ4iff5Vv9wKb8PmEACEG+EKSWb67Mvb4mDgAhSB+CHPLNk7nXuwwBIATpQpBLvjky97qfKQCEID4EOeWbH3OvmxkDQAjGhyC3fHNj7nVC0gdCMN5UhjNLyDfn5v6gXJL0ixA4jknrEvLNtTnfKHcyB4DbwQbu1o0S8s2Dud4q9n/GTwnBFpdSO0rJN8edzwcQglK6N8epQr5PiRA4iTJ1VfJ9yYTASeStq5TvSyYETiJPXUr+s133/L6lEYI+QuOOz0K+L40QOIk09azk+5IJgZOIq2cp35dMCJzEuHrW8n3JhMBJDKsXId+XTAicRFi9KPm+ZELgJHbXi5TvSyYETqK9LiX/eczn/Paph+8lBO2sViHfl04InMTfelXyfemEYMXyCQHyPQMHDxqs8aGSVV72/1tvvFnb7aCk/GMN1tVuriUEyN8RwaWHAPk75PuhpYaglHz7zp/ZXPZderNeWgiQ3zQcsL2UECA/QHZXk7mHAPldZgfsn2sIkD9Acl/TuYUA+X1GRxyfSwiQP0Ju6Cm1hwD5oSYj2tUaAuRHSB16am0hKCX/5RJ+yTNUdlf7WkKA/C5DBfZPHQLkF5DcN8RUIUB+n5mCx0uHAPkF5YYOVTIEMV+5bt+3E/LiH3yh5g+1KxWCEIExbZB/SOrQt3MPAfKHGm9pP9cQvOJzfovNkbvmFgLkjxS967S5hAD5uyxGHqs9BMiPFBxyeq0hQH6IvURtagsB8hOJHdJNLSFA/hBridtOHQLkJxY6prupQoD8MbYynVM6BK/5JU8mkxHdlgoB8iMk5T41dwiQn9tggv5zhQD5CeSU6iJ1CEz+8VKTZ5w0BFKFAPlpfEzSS2wIkD+JtrSDWgieBD66dfjJH/ucz2U/rYtJe7M/k/olIAj2F7X3Je1NOlsGz0LgjKQ3kn60BMH22bGzWUam06oI2G3hgqRr/1723vZRIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAArUT+AN2ib3dC7nDpAAAAABJRU5ErkJggg=="
}));

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4e191308f580dbd170d51549400dc0b7.svg";
export { ForwardRef as ReactComponent };